import { alpha, Theme } from "@mui/material/styles";
import {
  BRAND_COLOR,
  ONBOARDING_DIALOG_HEADER_BG,
  ONBOARDING_DIALOG_HEADER_BORDER
} from "@kivunova/kivufrontendcommon";

export const formModalScrollbarSx = {
  "&::-webkit-scrollbar": {
    width: "8px"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
    borderRadius: "10px"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#555"
    }
  }
};

export const guidanceDialogPaperSx = () => ({
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "min(90vh, 720px)",
  display: "flex",
  flexDirection: "column",
  boxShadow: `0 24px 64px ${alpha(BRAND_COLOR, 0.22)}`,
  border: `1px solid ${alpha(BRAND_COLOR, 0.12)}`
});

export const guidanceDialogBackdropSx = (theme: Theme) => ({
  backdropFilter: "blur(6px)",
  backgroundColor: alpha(theme.palette.common.black, 0.45)
});

export const guidanceDialogHeaderSx = {
  flexShrink: 0,
  position: "relative" as const,
  px: 2.5,
  pt: 2.5,
  pb: 2,
  textAlign: "center" as const,
  background:
    ONBOARDING_DIALOG_HEADER_BG ??
    "linear-gradient(180deg, #edf6fc 0%, #e8f4fc 100%)",
  borderBottom: `1px solid ${ONBOARDING_DIALOG_HEADER_BORDER ?? "rgba(25, 118, 210, 0.2)"}`
};

export const guidanceDialogIconBadgeSx = {
  width: 36,
  height: 36,
  mx: "auto",
  mb: 1.25,
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: alpha(BRAND_COLOR, 0.1),
  border: `1px solid ${alpha(BRAND_COLOR, 0.14)}`,
  color: BRAND_COLOR
};

export const guidanceDialogBodySx = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto" as const,
  px: { xs: 2, sm: 2.5 },
  py: 2,
  bgcolor: "background.paper"
};

export const guidanceDialogFooterSx = {
  flexShrink: 0,
  px: { xs: 2, sm: 2.5 },
  pb: 2,
  pt: 1.5,
  bgcolor: "background.paper",
  borderTop: `1px solid ${alpha(BRAND_COLOR, 0.08)}`
};

export const guidancePrimaryButtonSx = {
  py: 0.65,
  backgroundColor: BRAND_COLOR,
  textTransform: "none" as const,
  fontWeight: 600,
  fontSize: "0.8125rem",
  boxShadow: `0 2px 8px ${alpha(BRAND_COLOR, 0.28)}`,
  "&:hover": {
    backgroundColor: "#5b36b0",
    boxShadow: `0 3px 12px ${alpha(BRAND_COLOR, 0.32)}`
  }
};

export const guidanceOutlinedButtonSx = {
  py: 0.65,
  textTransform: "none" as const,
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderColor: alpha(BRAND_COLOR, 0.35),
  color: BRAND_COLOR,
  "&:hover": {
    borderColor: BRAND_COLOR,
    bgcolor: alpha(BRAND_COLOR, 0.04)
  }
};
